export const TradeTeamCoverageReport = {
  sections: [],
};
